import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  totalItems: 0,
  totalPrice: 0,
  loading: false,
  error: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Fetch cart
    fetchCartRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCartSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload.items || [];
      state.totalItems = action.payload.totalItems || 0;
      state.totalPrice = action.payload.totalPrice || 0;
      state.error = null;
    },
    fetchCartFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add to cart
    addToCartRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    addToCartSuccess: (state, action) => {
      state.loading = false;
      // Update cart with new data from backend
      state.items = action.payload.items || state.items;
      state.totalItems = action.payload.totalItems || state.totalItems;
      state.totalPrice = action.payload.totalPrice || state.totalPrice;
      state.error = null;
    },
    addToCartFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update cart item
    updateCartItemRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCartItemSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload.items || state.items;
      state.totalItems = action.payload.totalItems || state.totalItems;
      state.totalPrice = action.payload.totalPrice || state.totalPrice;
      state.error = null;
    },
    updateCartItemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Remove from cart
    removeFromCartRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    removeFromCartSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload.items || state.items;
      state.totalItems = action.payload.totalItems || state.totalItems;
      state.totalPrice = action.payload.totalPrice || state.totalPrice;
      state.error = null;
    },
    removeFromCartFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear cart
    clearCartRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    clearCartSuccess: (state) => {
      state.loading = false;
      state.items = [];
      state.totalItems = 0;
      state.totalPrice = 0;
      state.error = null;
    },
    clearCartFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCartRequest,
  fetchCartSuccess,
  fetchCartFailure,
  addToCartRequest,
  addToCartSuccess,
  addToCartFailure,
  updateCartItemRequest,
  updateCartItemSuccess,
  updateCartItemFailure,
  removeFromCartRequest,
  removeFromCartSuccess,
  removeFromCartFailure,
  clearCartRequest,
  clearCartSuccess,
  clearCartFailure,
} = cartSlice.actions;

// Thunk-style action creators for easier usage
export const fetchCart = () => (dispatch) => {
  dispatch(fetchCartRequest());
};

export const addToCart = (data) => (dispatch) => {
  dispatch(addToCartRequest());
  return { payload: data };
};

export const updateCartItem = (data) => (dispatch) => {
  dispatch(updateCartItemRequest());
  return { payload: data };
};

export const removeFromCart = (cartItemId) => (dispatch) => {
  dispatch(removeFromCartRequest());
  return { payload: cartItemId };
};

export const clearCart = () => (dispatch) => {
  dispatch(clearCartRequest());
};

export default cartSlice.reducer;